import {createApp} from 'vue'
import GruppeadgangsanmodningList from './GruppeadgangsanmodningList'

const el = '.kb-component--gruppeadgangsanmodning-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GruppeadgangsanmodningListDOM)=>{
            const props = {
                guid: GruppeadgangsanmodningListDOM.dataset.searchGuid,
                skip: parseInt(GruppeadgangsanmodningListDOM.dataset.skip) ?? 0,
                take: parseInt(GruppeadgangsanmodningListDOM.dataset.take) ?? 10
            }
            const component = createApp(GruppeadgangsanmodningList, props).use(Store)
            component.mount(GruppeadgangsanmodningListDOM)
        })
    }
}